<template>
    <div class="lore-hero" id="lore-hero">
        <div class="lore-center">
            <div class="top-section lore-container" ref="topSection">
                <div class="usb-icon">
                    <svg @click="$router.push('/')" width="76" height="33" viewBox="0 0 76 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6562 6.62362H59.9504C65.6681 6.62362 70.3033 11.2588 70.3033 16.9766C70.3033 22.6943 65.6681 27.3295 59.9504 27.3295H16.6562C10.9385 27.3295 6.30331 22.6943 6.30331 16.9766C6.30331 11.2588 10.9385 6.62362 16.6562 6.62362ZM0.65625 16.9766C0.65625 8.14001 7.81969 0.976562 16.6562 0.976562H59.9504C68.7869 0.976562 75.9504 8.14001 75.9504 16.9766C75.9504 25.8131 68.7869 32.9766 59.9504 32.9766H16.6562C7.81969 32.9766 0.65625 25.8131 0.65625 16.9766ZM16.6595 14.1562C15.1001 14.1562 13.8359 15.4204 13.8359 16.9798C13.8359 18.5392 15.1001 19.8033 16.6595 19.8033H59.9536C61.513 19.8033 62.7771 18.5392 62.7771 16.9798C62.7771 15.4204 61.513 14.1562 59.9536 14.1562H16.6595Z" fill="#E5E5E5"/>
                    </svg>
                </div>
                <div class="row top-content row-no-margin">
                    <div class="col col-1 col-spacer"></div>
                    <div class="col col-8">
                        <h2 class="title"><strong>USB Club</strong></h2>
                        <h1 class="subtitle">Building a Memory Network</h1>
                    </div>
                </div>
                <div class="row top-details row-no-margin">
                    <div class="col col-1 col-spacer"></div>
                    <div class="col col-7 col-details">
                        <div class="details-part">
                            <p>Published Winter 2025<br>New York City, U.S.</p>
                        </div>
                        <div class="details-part">
                            <p>Yatú Espinosa<br>Norm O'Hagan</p>
                        </div>
                        <div class="details-part">
                            <p>Fill in the Blank Inc.<br>Est. 2021</p>
                        </div>
                    </div>
                </div>
                <div class="row top-content row-no-margin top-illustration">
                    <div class="col col-9"></div>
                    <div class="col col-3">
                        <FolderHeroIllustration />
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import FolderHeroIllustration from '@/components/Lore/illos/FolderHeroIllustration.vue';
  
  export default {
    components: {
      FolderHeroIllustration
    },
    mounted() {
        setTimeout(() => {
            this.$refs.topSection.classList.add('show');
        }, 200);
    }
  };
  </script>
  
  <style scoped>
  .lore-hero {
    background: #333;
    color: #fff;
    position: relative;
    z-index: 100000;
  }
  
  .top-section {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .top-content {
    position: relative;
    margin-top: 22rem;
    z-index: 10;
  }
  
  .usb-icon {
    text-align: center;
    margin-top: 6.2rem;
  }

  .usb-icon svg {
    cursor: pointer;
  }

  .usb-icon svg:active {
    transform: scale(0.9);
  }
  
  .title {
    font-size: 4.2rem;
    line-height: 1;
    letter-spacing: -0.05em;
    font-weight: bold;
    font-family: "Untitled Sans", sans-serif;
    color: #ffffff;
  }
  
  .subtitle {
    font-size: 7.2rem;
    line-height: 1.2;
    letter-spacing: -0.05em;
    font-family: "Untitled Serif", serif;
    color: #ededed;
    font-weight: 100;
  }
  
  .top-details {
    margin-top: 2.8rem;
    margin-bottom: 6.2rem;
  }
  
  .top-details p {
    font-size: 2rem;
    line-height: 1.2;
    letter-spacing: -0.05em;
    font-family: "Untitled Serif", serif;
    color: #d8d8d8;
    margin-top: 0 !important;
  }
  
  .top-illustration {
    position: absolute;
    bottom: -28px;
    /* right: 6.2rem; */
    z-index: 0;
    width: 100%;
    pointer-events: none;
  }
  
  .nav-section {
    background: #222;
    padding: 2rem 0;
  }
  
  nav ul {
    display: flex;
    gap: 2.4rem;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  nav a {
    color: #7E7E7E;
    text-decoration: none;
    font-size: 1.6rem;
    font-weight: 500;
    font-family: "Untitled Sans", sans-serif;
    line-height: 1;
    letter-spacing: -0.05em;
    transition: all 200ms ease-in-out;
  }
  
  nav a:hover {
    color: #fff;
    cursor: pointer;
  }

  /* animtions */

  .top-section .top-details,
  .top-section .title,
  .top-section .subtitle,
  .top-section .usb-icon {
    opacity: 0;
    transition: all 300ms cubic-bezier(0.42, 0, 0.11, 1.02);
    transform: translateY(12px);
  }

  .top-section .subtitle {
    transition-delay: 100ms;
  }

  .top-section .title {
    transition-delay: 175ms;
  }

  .top-section .usb-icon {
    transition-delay: 200ms;
  }  

  /* .top-section .details-1,
  .top-section .details-2,
  .top-section .details-3 {
    opacity: 0;
    transition: all 250ms cubic-bezier(0.42, 0, 0.11, 1.02);
  }

  .top-section .title,
  .top-section .subtitle {
    opacity: 0;
    transition: all 350ms cubic-bezier(0.42, 0, 0.11, 1.02);
    transform: translateY(12px);
  }

  .top-section .title {
    transition-delay: 75ms;
  }

  .top-section .details-1,
  .top-section .details-2,
  .top-section .details-3 {
    transform: translateX(-8px);
  }

  .top-section .details-1 {
    transition-delay: 50ms;
  }

  .top-section .details-2 {
    transition-delay: 100ms;
  }

  .top-section .details-3 {
    transition-delay: 150ms;
  } */
  

  .top-section.show .title,
  .top-section.show .subtitle,
  .top-section.show .top-details,
  .top-section.show .details-1,
  .top-section.show .details-2,
  .top-section.show .details-3,
  .top-section.show .usb-icon {
    opacity: 1;
    transform: translate(0,0);
  }

  .col-details {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1.6rem;
  }

  .details-part {
    width: 33%;
  }

  @media (max-width: 768px) {
    .lore-hero .title {
        font-size: 2.8rem;
        margin-bottom: 0.4rem;
    }
    .lore-hero .subtitle {
        font-size: 3.2rem;
    }
    .lore-hero .lore-container {
        max-width: 95vw;
    }
    .top-illustration svg {
        width: 42vw;
    }
    .top-illustration {
        width: fit-content;
        right: -9px;
        bottom: -11px;
    }
    .top-illustration .col-3 {
        max-width: fit-content;
        padding: 0;
    }
    .top-content {
        margin-top: 13rem;
    }

    .col-details {
        display: flex;
        flex-direction: column;
        gap: 2.4rem;
    }

    .details-part {
        width: 100%;
    }
    
}
  
  </style>
  